import { createContext,  useEffect, useState } from 'react';
import { Merchant, MerchantsResponse, MerchantResponse, ApplicationResponse } from '../../models/interfaces';
import topApi from '../../components/api/ToPApi';
import { Client, TreeNodeModel } from '../../components/tree/types';




type MerchantsContextProps = {
    merchants: Merchant[];
    totalPage: number;
    isLoading: boolean;
    loadMerchants: (page: number) => Promise<void>;
    addMerchant: ( merchant: Merchant ) => Promise<string>;
    updateMerchant: ( merchant: Merchant ) => Promise<string>;
    deleteMerchant: ( id: number ) => Promise<string>;
    suspendMerchant: ( id: number ) => Promise<string>;
    activateMerchant: ( id: number ) => Promise<string>;
    getWithoutITBMSConfiguration: ( ) => Promise<Merchant[]>;
    
}



export const MerchantsContext = createContext({} as MerchantsContextProps);

export const MerchantsProvider = ({ children }: any) => {

    const [merchants, setMerchants] = useState<Merchant[]>([]);
    const [totalPage, setTotalPage] = useState<number>(0);
    const [isLoading, setIsLoading] = useState(false);
    const pageSize = 15;


 const loadMerchants = async (pageActual) => {

       try {
        setIsLoading(true);
            const resp = await topApi.get<MerchantsResponse>('/merchant/getMerchants/'+pageActual+'/'+pageSize);
            if(resp.status == 200){
                setMerchants([...resp.data.merchants]);
                setTotalPage(resp.data.pages);
            }
            setIsLoading(false);
       } catch (error) {
            
       }
    }

    const addMerchant = async (merchant: Merchant)  => {
        try {
            setIsLoading(true);
            merchant.contract_code = ''+merchant.contract_code;
            merchant.terminal_id = ''+merchant.terminal_id;
            merchant.category_code = ''+merchant.category_code;
            merchant.zip_code = ''+merchant.zip_code;
            merchant.merchant_id = undefined;
            const resp = await topApi.post<MerchantResponse>('/merchant/', { merchant });
            setMerchants([...merchants, resp.data.merchant]);
            setIsLoading(false);
            return 'success'
            
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }
    

    const updateMerchant = async (merchant:Merchant) => {
        try {
            setIsLoading(true);
            
            const resp = await topApi.put<Merchant>(`/merchant/${merchant.merchant_id}`, { merchant });
            
                setMerchants(merchants.map(prod => {    
                    return (prod.merchant_id === merchant.merchant_id)
                        ? resp.data["merchant"]
                        : prod;
                }));
                setIsLoading(false);
            return 'success'
            
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
        
        
    }

    const deleteMerchant = async (id: number) => {
        try {
            setIsLoading(true);
            await topApi.delete<Merchant>(`/merchant/${id}`);
            setMerchants((prevMerchants) =>
                prevMerchants.filter((merchant) => merchant.merchant_id! !== id)
            );
            setIsLoading(false);
            return 'success'
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }

    const suspendMerchant = async (id: number) => {
        try {
            setIsLoading(true);
            await topApi.post<Merchant>(`/merchant/suspend/${id}`);
            setMerchants(merchants.map(prod => {    
                if(prod.merchant_id === id){
                    prod.merchant_status = 'INA'
                }
                return prod;
            }));
            setIsLoading(false);
            return 'success'
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }

    const activateMerchant = async (id: number) => {
        try {
            setIsLoading(true);
            await topApi.post<Merchant>(`/merchant/activate/${id}`);
            setMerchants(merchants.map(prod => {    
                if(prod.merchant_id === id){
                    prod.merchant_status = 'ACT'
                }
                return prod;
            }));
            setIsLoading(false);
            return 'success'
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }

    const getWithoutITBMSConfiguration = async () => {

        try {
             const resp = await topApi.get<MerchantsResponse>('/merchant/getWithoutITBMSConfiguration');
             if(resp.status == 200){
                return resp.data.merchants;
             }
             return []  ;
        } catch (error) {
             
        }
     }

    return (
        <MerchantsContext.Provider value= {{ merchants, totalPage, loadMerchants, addMerchant, updateMerchant, deleteMerchant,
        suspendMerchant, activateMerchant, isLoading, getWithoutITBMSConfiguration }}>
            { children }
        </MerchantsContext.Provider>
    );
}